
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prestamos/hipotecarios/index_",
      function () {
        return require("private-next-pages/prestamos/hipotecarios/index_.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prestamos/hipotecarios/index_"])
      });
    }
  